import React, { useEffect, useMemo, useState } from 'react';
import { Box, ButtonBase, Dialog, IconButton, Typography, makeStyles } from '@material-ui/core';
import _ from 'lodash';
import { AutoCompleteSelect } from '../../../../../components';
import { CloseIcon } from '../../../../../components/Icon';
import { i18n } from '../../../../../language';
import { baseCassConfirm } from '../baseCss';
import { bedStatusAPI } from '../../../../../apis';
import { bsMlookupListFunc } from '../../../bsEnumeration';
import { bedP as P } from '../../../bsApp';
import { classNames, getUUID } from '../../../../../utils';
import ServiceOrders from '../../ServiceOrder/AddServiceOrders';
import { useEnableServiceOrder } from '../../../../../utils/hooks';
import handleGetBsCleansingType from '../../../../../utils/handleGetBsCleansingType';
const useStyles = makeStyles((theme) => ({
  buttonBase: {
    '&.Mui-disabled': {
      backgroundColor: '#c0c6cb',
    },
  },
}));
export default function Dischargeconfirmation({
  closePop,
  open,
  comfirmHandle,
  allData,
  hospCode,
  wardLocation,
  defaultLocation,
}) {
  const baseClasses = baseCassConfirm();
  const useStyle = useStyles();
  const [BsMlookupList, setBsMlookupList] = useState(null);

  // 床位上打开才有默认remark
  const defaultRemark = useMemo(() => {
    if (allData) {
      return `${allData?.ccWardCd} 床 ${allData?.bedNo}`;
    } else return '';
  }, [allData]);
  const [orderService, setOrderService] = useState([
    {
      serviceRemark: defaultRemark,
      serviceType: '',
      id: getUUID(),
    },
  ]);
  const { enableOrderService } = useEnableServiceOrder();
  const [wardCodings, setWardCodings] = useState([]);

  const getBsMlookupList = async () => {
    try {
      const getBsMlookupList = await bedStatusAPI.getBsMlookupList();
      setBsMlookupList(getBsMlookupList.result);
      return getBsMlookupList.result;
    } catch {}
  };

  useEffect(() => {
    (async () => {
      const result = await getBsMlookupList();
      if (!ValueData[P.dischargeDestination]) {
        setValueData({
          [P.dischargeDestination]: bsMlookupListFunc.isTypeLookupValueExist(result, 'bs_dischg_dest', 'H') ? 'H' : '',
        });
      }
    })();
  }, []);

  const [ValueData, setValueData] = useState({
    [P.dischargeDestination]: allData?.[P.dischargeDestination] ?? '',
  });

  const onChangeHandle = (type, key) => {
    return (event) => {
      if (type === 'select') {
        setValueData({ ...ValueData, [key]: event });
      }
    };
  };

  const comfirmClick = () => {
    comfirmHandle?.({
      ...ValueData,
      orderService: enableOrderService
        ? _.map(orderService, (item) => ({
            serviceRemark: item.serviceRemark,
            serviceType: item.serviceType,
          }))
        : null,
      serviceLocation: _.find(locationOptions, (item) => item.value === defaultLocation)?.location,
    });
  };

  const getWardCodingList = async () => {
    try {
      const params = {
        hospCode,
        wardLocation,
      };
      const { result } = await bedStatusAPI.getWardCodingList(params);
      setWardCodings(result?.wardCodings);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    getWardCodingList();
  }, []);

  const locationOptions = [
    ..._.map(wardCodings, (item) => ({
      text: item.locationDesc,
      value: `${item.ccWardLocation} ${item.ccWardCd}`,
      location: item.location,
    })),
  ];

  return (
    <Dialog open={open} maxWidth={false}>
      <div className={baseClasses.root}>
        <div className={baseClasses.header} style={{ padding: '2.187rem 0 0.62rem' }}>
          <Typography className={baseClasses.headerTitle}>
            {i18n.t('BEDSTATUS_DISCHARGE_ORDER_CONFIRMATION')}
          </Typography>
          <IconButton
            id="bed_dischargeconfirmation_close_btn"
            className={baseClasses.closeIcon}
            onClick={closePop}
            style={{ marginRight: '-12px' }}
          >
            <CloseIcon />
          </IconButton>
        </div>
        <Typography className={baseClasses.areYouSureYouWou} style={{ fontSize: '1.125rem' }}>
          {i18n.t('BEDSTATUS_ARE_YOU_SURE_TO_ISSUE_DISCHARGE_ORDER_FOR_BED_', { value: allData.bedNo })}
        </Typography>
        <Typography
          style={{
            margin: '1.87rem 0 0.75rem 0',
            color: '#666666',
            fontSize: '0.875rem',
            fontFamily: 'NotoSans-Medium',
          }}
        >
          {i18n.t('BEDSTATUS_DISCHARGE_DESTINATION')}
        </Typography>
        <AutoCompleteSelect
          id="bed_dischargeconfirmation_destination"
          itemList={bsMlookupListFunc.getTypeLookupFormat(BsMlookupList, 'bs_dischg_dest')}
          value={ValueData?.[P.dischargeDestination]}
          onChange={onChangeHandle('select', P.dischargeDestination)}
        />
        {enableOrderService && (
          <>
            <Typography
              style={{
                margin: '0.75rem 0',
                color: '#666666',
                fontSize: '0.875rem',
                fontFamily: 'NotoSans-Medium',
              }}
            >
              Service Location<span style={{ color: '#FF0300', fontSize: '1rem' }}>*</span>
            </Typography>
            <AutoCompleteSelect
              id="bed_dischargeconfirmation_destination"
              itemList={locationOptions}
              value={defaultLocation}
              disabled
            />
            <ServiceOrders
              serviceList={orderService}
              setOrderService={setOrderService}
              allData={allData}
              defaultRemark={defaultRemark}
              type="discharge"
              defaultCleaningCase={handleGetBsCleansingType(allData)}
            />
          </>
        )}
        <Box display="flex" justifyContent="center" style={{ margin: '1.88rem 0' }}>
          <ButtonBase
            id="bed_dischargeconfirmation_cancel"
            className={baseClasses.cancelBtn}
            style={{ marginRight: '1.313rem' }}
            onClick={closePop}
          >
            {i18n.t('BEDSTATUS_CANCEL')}
          </ButtonBase>
          <ButtonBase
            id="bed_dischargeconfirmation_confirm"
            className={classNames(baseClasses.configBtn, useStyle.buttonBase)}
            onClick={comfirmClick}
            disabled={!ValueData?.[P.dischargeDestination]}
          >
            {i18n.t('BEDSTATUS_CONFIRM')}
          </ButtonBase>
        </Box>
      </div>
    </Dialog>
  );
}
